import React, { useState, useEffect } from 'react'
import './styles.css'

import { useLocation, useSearchParams } from 'react-router-dom'

import { Button, Snackbar, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material/styles'
import CustomCheckbox from 'src/components/CustomCheckbox'
import { useQuery } from 'src/hooks'

const LoginInput = styled(TextField)(() => ({
  marginBottom: '12px',
  fontFamily: 'Source Sans 3',
  '& .MuiInputBase-input': {
    fontFamily: 'Source Sans 3'
  }
}))

const TimerButton = ({ body }) => {
  const [timeLeft, setTimeLeft] = useState(59)
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    let timer = null

    if (!isActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            setIsActive(true)
            clearInterval(timer)
            return 0
          }
          return prevTime - 1
        })
      }, 1000)
    }

    return () => {
      if (timer) clearInterval(timer)
    }
  }, [isActive, timeLeft])

  const action = () => {
    fetch(window._env_.REACT_APP_API_HOST + '/v1/special-offer/companies/welcome-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(response => {
      if (response.status) {
        setTimeLeft(59)
        setIsActive(false)
      }
    })
  }

  return (
    <Button
      sx={{
        mb: '16px',
        borderRadius: 0,
        textTransform: 'none',
        height: '60px',
        backgroundColor: '#0246F8',
        fontFamily: 'Source Sans 3'
      }}
      variant='contained'
      disabled={!isActive}
      onClick={action}
    >
      {isActive ? 'Resend link' : `Resend link in ${timeLeft} sec`}
    </Button>
  )
}

const Registration = ({ loc = 'uk' }) => {
  const query = useQuery()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState(query.get('email') || '')
  const [companyName, setCompanyName] = useState('')

  const [phone, setPhone] = useState('')
  const [employees, setEmployees] = useState('')

  const [chkecked, setChecked] = useState('')

  const [dataSent, setDataSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [errors, setErrors] = useState({})
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.has('error')) {
      setErrors({ ...errors, tokenError: searchParams.get('error') })
      setTimeout(() => {
        setErrors({ ...errors, tokenError: null })
      }, 5000)
      searchParams.delete('error')
      setSearchParams(searchParams)
    }
  }, [])

  const validateForm = () => {
    let errors = {}

    if (!email) {
      errors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid'
    }

    if (!firstName) {
      errors.firstName = 'First Name is required'
    }

    if (!lastName) {
      errors.lastName = 'Last Name is required'
    }

    if (!companyName) {
      errors.companyName = 'Company Name is required'
    }

    if (!chkecked) {
      errors.agree = 'You need to agree to the TOBA and EULA'
    }

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const body = {
    sourceUrl: window.location.href,
    userEmail: email,
    userFirstName: firstName,
    userLastName: lastName,
    companyName: companyName,
    phoneNumber: phone,
    employeesNumber: employees
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (validateForm()) {
      setLoading(true)

      fetch(window._env_.REACT_APP_API_HOST + '/v1/special-offer/companies/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status) {
          setLoading(false)
          setDataSent(true)
          // clearForm()
          // setSuccessMessage('Success! Data has been sent.')
        } else {
          setLoading(false)
          // setErrorMessage('Something went wrong, please try again')
        }
      })
    }
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setError(false)
  }

  return (
    <div className='login-page column'>
      <div className='logo'>
        <img src='/images/logo.png' width={'300px'} alt='' />
      </div>
      <div className='login-form-container mob-login-form-container column'>
        <form className='column' onSubmit={handleSubmit}>
          {dataSent ? (
            <>
              <div className='column column-center'>
                <svg
                  style={{ marginBottom: '24px' }}
                  width='112'
                  height='112'
                  viewBox='0 0 112 112'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    opacity='0.16'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z'
                    fill='#00BC62'
                  />
                  <g filter='url(#filter0_d_360_35055)'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M79.7744 38.82C78.648 37.4334 76.6041 37.2221 75.2205 38.351L47.5584 60.8834L36.3493 54.4157C35.1674 53.7316 33.6784 53.8707 32.6407 54.753C31.2812 55.9098 31.1129 57.9619 32.2652 59.3263L39.3125 67.6496L39.2977 67.6626L44.7821 74.1174L44.9929 74.3435C45.6218 74.9478 46.432 75.25 47.2403 75.25C48.0893 75.25 48.9346 74.9182 49.5691 74.2638L79.5895 43.1207C80.7289 41.9417 80.8084 40.0936 79.7744 38.82Z'
                      fill='url(#paint0_linear_360_35055)'
                    />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_360_35055'
                      x='31.5'
                      y='37.625'
                      width='49'
                      height='39.125'
                      filterUnits='userSpaceOnUse'
                      colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset dy='1.5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.0032804 0 0 0 0 0.61672 0 0 0 0 0.347725 0 0 0 1 0'
                      />
                      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_360_35055' />
                      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_360_35055' result='shape' />
                    </filter>
                    <linearGradient
                      id='paint0_linear_360_35055'
                      x1='74.1597'
                      y1='5.09505'
                      x2='38.0323'
                      y2='9.27992'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#00BA97' />
                      <stop offset='1' stopColor='#00BC62' />
                    </linearGradient>
                  </defs>
                </svg>
                <p className='login-title mb25'> Link to the platform sent!</p>
              </div>
              <p style={{ textAlign: 'center' }} className='reset-pass-description fs20 lh12 mb140'>
                Thank you for choosing Gallagher Security Awareness to help improve your organisations security posture.
                One of our team will be in touch shortly to provide you with your invoice, if you have any queries
                please contact us at
                <br />
                <span style={{ fontWeight: '600' }}>CyberRM@ajg.com.</span>
              </p>
              <p
                style={{
                  textAlign: 'center',
                  marginBottom: '16px'
                }}
                className='reset-pass-description'
              >
                Check your inbox (and spam folder) for an email from us or <br />{' '}
                <span style={{ cursor: 'pointer', color: '#0246F8' }} onClick={() => window.location.reload()}>
                  back to try another email
                </span>
              </p>

              <TimerButton body={body} />
            </>
          ) : (
            <>
              <p className='login-title' style={{ fontSize: '30px' }}>
                Welcome to Security Awareness
              </p>
              <p style={{ marginBottom: 30, opacity: 0.8, marginTop: 20, fontSize: '16px' }}>
                Please enter required information and we'll send you a magic link.
              </p>

              <div className='column'>
                <div className='row' style={{ gap: 12 }}>
                  <LoginInput
                    error={errors.firstName}
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    placeholder='First Name*'
                    fullWidth
                  />
                  <LoginInput
                    error={errors.lastName}
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    placeholder='Last Name*'
                    fullWidth
                  />
                </div>
                <div className='row' style={{ gap: 12 }}>
                  <LoginInput
                    error={errors.email}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder='Work email*'
                    fullWidth
                  />
                  <LoginInput
                    error={errors.companyName}
                    value={companyName}
                    onChange={e => setCompanyName(e.target.value)}
                    placeholder='Company name*'
                    fullWidth
                  />
                </div>
                <LoginInput
                  error={errors.phone}
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  placeholder='Phone number'
                  fullWidth
                />
                <LoginInput
                  error={errors.employees}
                  value={employees}
                  onChange={e => setEmployees(e.target.value)}
                  placeholder='Number of employees'
                  fullWidth
                />

                <div className='row row-center'>
                  <CustomCheckbox chkecked={chkecked} onChange={() => setChecked(prev => !prev)} />
                  <p>
                    I have read and agree to the{' '}
                    <a
                      style={{ color: '#0246F8', textDecoration: 'none' }}
                      href='/assets/security-awareness-toba.pdf'
                      target='_blank'
                    >
                      TOBA
                    </a>{' '}
                    and{' '}
                    <a
                      style={{ color: '#0246F8', textDecoration: 'none' }}
                      href='/assets/security-awareness-eula.pdf'
                      target='_blank'
                    >
                      EULA
                    </a>
                  </p>
                </div>
              </div>

              {(error || errors.agree) && <p className='error-text'>{errors.agree}</p>}

              <LoadingButton
                type='submit'
                loading={loading}
                onClick={handleSubmit}
                sx={{
                  mt: '30px',
                  mb: '16px',
                  borderRadius: 0,
                  textTransform: 'none',
                  height: '60px',
                  backgroundColor: '#0246F8',
                  fontFamily: 'Source Sans 3'
                }}
                variant={'contained'}
              >
                Activate
              </LoadingButton>

              {loc == 'uk' && (
                <p className='fs16 text-center mb20 lh12'>
                  All features for <span className='fw700'>£1188 + VAT per annum</span>, the equivalent of just{' '}
                  <span className='fw700'>£99 + VAT per month</span>.
                </p>
              )}
              {loc == 'us' && (
                <p className='fs16 text-center mb20 lh12'>
                  All features for <span className='fw700'>5000 USD + Local Tax per annum</span>, the equivalent of just{' '}
                  <span className='fw700'>417 USD + Local Tax per month</span>.
                </p>
              )}
              {loc == 'eu' && (
                <p className='fs16 text-center mb20 lh12'>
                  All features for <span className='fw700'> €1,500 + VAT per annum</span>, the equivalent of just{' '}
                  <span className='fw700'>€125 + VAT per month</span>.
                </p>
              )}
              {loc == 'aus' && (
                <p className='fs16 text-center mb20 lh12'>
                  All features for <span className='fw700'>A$2600 + GST per annum</span>, the equivalent of just{' '}
                  <span className='fw700'>A$216.66 + GST per month</span>.
                </p>
              )}
            </>
          )}
        </form>

        {errors?.tokenError && (
          <div className='column column-center'>
            <p className='error-text' style={{ marginTop: 20 }}>
              {' '}
              {errors?.tokenError}
            </p>
          </div>
        )}
      </div>
      <div className='spacer'></div>

      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: 0
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={error}
        autoHideDuration={6000}
        onClose={handleClose}
        message={error}
      />
      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: 0
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={!!errors?.tokenError}
        autoHideDuration={6000}
        onClose={handleClose}
        message={errors?.tokenError}
      />
    </div>
  )
}

export default Registration
